import React, { useContext } from "react";
import { api } from "../../api";
import Ctx from "../../contexts/AppContext";
import { crd, bdg, btnP } from "../../constants/styles";

function ServicePersonsPage() {
  const { t, h, sps, setSps, go, flash, showConfirm, setSelTid } = useContext(Ctx);
  return <div style={{ paddingTop: 16 }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
      <h2 style={{ color: h.tx, fontSize: 18, fontWeight: 700, margin: 0 }}>{t.servicePersons}</h2>
      <button onClick={() => go("addServicePerson")} style={{ background: h.ac, border: "none", color: "#fff", padding: "8px 14px", borderRadius: 10, cursor: "pointer", fontSize: 12, fontWeight: 600 }}>+ {t.add}</button>
    </div>
    {sps.length === 0 && <div style={{ color: h.sc, textAlign: "center", padding: 40, fontSize: 13 }}>{t.noData}</div>}
    {sps.map(sp => <div key={sp.id} style={crd(h)}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <div style={{ color: h.tx, fontWeight: 600, fontSize: 14 }}>{sp.name}</div>
          <div style={{ color: h.sc, fontSize: 12 }}>{sp.ph} · {sp.skill || "General"}</div>
        </div>
        <span style={bdg(sp.active ? `${h.gn}20` : `${h.rd}20`, sp.active ? h.gn : h.rd)}>{sp.active ? t.active : "Inactive"}</span>
      </div>
      <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
        <button onClick={() => { setSelTid(sp.id); go("editServicePerson"); }} style={{ flex: 1, padding: 8, borderRadius: 8, border: "none", background: `${h.ac}15`, color: h.ac, cursor: "pointer", fontSize: 12, fontWeight: 600 }}>{"✏️ " + t.edit}</button>
        <button onClick={() => showConfirm(t.deleteSpConfirm, async () => { await api.deleteServicePerson(sp.id); setSps(sps.filter(x => x.id !== sp.id)); flash(t.spDeleted); })} style={{ flex: 1, padding: 8, borderRadius: 8, border: "none", background: `${h.rd}15`, color: h.rd, cursor: "pointer", fontSize: 12, fontWeight: 600 }}>{"✕ " + t.delete}</button>
      </div>
    </div>)}
  </div>;
}

export default ServicePersonsPage;
